import {useEffect, useState} from 'react'
import {
  Badge,
  Card,
  Col,
  Button,
  Form,
  Modal,
  Row,
  Spinner,
  Table,
  Collapse,
  Breadcrumb,
} from 'react-bootstrap'
import {ITask, ITaskAddTag, ITaskApproval, ITaskEditTag} from '../../interface/task/task'
import TextField from '../../components/TextField'
import {FormikProps, useFormik} from 'formik'
import {ColumnDef} from '@tanstack/react-table'
import {KTIcon} from '../../../_metronic/helpers'
import {TABLE_ACTION, TableAction} from '../../constants/enum/table-action'
import {IDiscipline} from '../../interface/discipline/discipline'
import {IPageMeta} from '../../interface/paging/meta-paging'
import {DEFAULT_META, DEFAULT_PAGE_OPTION} from '../../constants/page-option/page-option'
import {IPageOption} from '../../interface/paging/paging'
import TableData from '../../components/Table'
import {type, userInfo} from 'os'
import ButtonComp from '../../components/Button'
import SelectActive from '../../components/SelectActive'
import Select from '../../components/Select'
import Swal from 'sweetalert2'
import {DEFAULT_CORMFIRM_MODAL} from '../../constants/swal'
import {ITag, ITagCreate} from '../../interface/tag'
import {Link, useNavigate, useSearchParams} from 'react-router-dom'
import {
  ExportTagInTaskService,
  GetTaskByIdService,
  TaskAddTagService,
  TaskApprovalService,
  TaskDeleteTagService,
  TaskEditTagService,
  TaskSubmitApprovalService,
} from '../../service/task.service'
import {GetAvailableTagService, GetTagService} from '../../service/tag.service'
import {DEFAULT_SUCCESS_MODAL, DEFAULT_ERROR_MODAL} from '../../constants/errors/error-model'
import {useUserSelector} from '../../store/user'
import {GetPlantByCompanyService} from '../../service/plant.service/plant.service'
import {GetDisciplineByPlantService} from '../../service/discipline.service/discipline'
import {IPlant} from '../../interface/plant/plant'
import {ITagType} from '../../interface/tag-type'
import {GetTagTypeByDisciplineService} from '../../service/tag-type.service'
import DOMPurify from 'dompurify'
import exportFile from '../../modules/report/ExportFile'
import Multiselect from '../../components/MultiSelect'
import {GetAttributeByTagTypeIdService} from '../../service/attribute.service'
import RegisterTagDetail from '../../modules/register/RegisterTagDetail'
import {useCommonSelector, useCommonDispatch} from '../../store/common'

const initialValues: ITask = {
  taskNumber: '',
  darNumber: '',
  darTaskId: '',
  darTaskStudyCode: '',
  companyGroup: '',
  company: '',
  companyId: '',
  plant: '',
  plantId: '',
  status: '',
  remark: '',
  tagNumber: '',
  tagDescription: '',
}
const initialValuesTag: ITaskEditTag = {
  taskId: '',
  tagId: '',
  isDemolishTag: true,
  attributes: [],
  attributeGroups: [],
}
const AssignTaskPage = () => {
  const navigate = useNavigate()
  const {user, isSuperAdmin, isUser, myCompany} = useUserSelector()
  const {query} = useCommonSelector()

  const [type, setType] = useState<string>(TABLE_ACTION.CREATE)
  const [searchParams, setSearchParams] = useSearchParams()
  const formik: FormikProps<ITaskEditTag> = useFormik({
    initialValues: initialValuesTag,
    onSubmit: async (values, {setSubmitting}) => {
      setSubmitting(false)
    },
  })
  const formikFilter: FormikProps<ITask> = useFormik({
    initialValues: initialValues,
    onSubmit: async (values, {setSubmitting}) => {
      await handleGetTask(searchParams.get('id') as string, values.tagNumber, values.tagDescription)
      setSubmitting(false)
    },
  })
  const formikFilterTag: FormikProps<any> = useFormik({
    initialValues: {
      disciplineId: '',
      plantId: '',
    },
    onSubmit: async (values, {setSubmitting}) => {
      setSubmitting(false)
    },
  })
  const [columns, setColumns] = useState<ColumnDef<any>[]>([])
  const [task, setTask] = useState<any>()
  const [columnsAdd, setColumnsAdd] = useState<ColumnDef<any>[]>([])
  const [meta, setMeta] = useState<IPageMeta>(DEFAULT_META)
  const [pageOption, setPageOption] = useState<IPageOption>(DEFAULT_PAGE_OPTION)
  const [modalShow, setModalShow] = useState(false)
  const [modalAddTag, setModalAddTag] = useState(false)
  const [attribute, setAttribute] = useState<any[]>([])
  const [tags, setTags] = useState<ITag[]>([])
  const [modalTags, setModalTags] = useState<ITag[]>([])
  const [metaTags, setMetaTags] = useState<IPageMeta>(DEFAULT_META)
  const [pageOptionTag, setPageOptionTag] = useState<IPageOption>(DEFAULT_PAGE_OPTION)
  const [disciplinesSearch, setDisciplinesSearch] = useState<IDiscipline[]>()
  const [disciplines, setDisciplines] = useState<IDiscipline[]>()
  const [plants, setPlants] = useState<IPlant[]>()
  const [tagTypesList, setTagTypesList] = useState<ITagType[]>()
  const [attributeTag, setAttributeTag] = useState<any[]>([])
  const [tagSelected, setTagSelected] = useState<any>({
    code: '',
    name: '',
    isDemolished: false,
  })
  const [companyFilterTag, setCompanyFilterTag] = useState<string>()
  const [plantFilterTag, setPlantFilterTag] = useState<string>()

  useEffect(() => {
    const _columns: ColumnDef<any>[] = [
      // {
      //   header: 'No',
      //   accessorFn: (row) => row.no,
      //   id: 'no',
      //   cell: (info) => info.getValue(),
      // },
      {
        header: 'Action',
        id: 'action',
        cell: (info) => (
          <>
            {task?.updatable ? (
              <div className='d-flex justify-content-center'>
                <>
                  <Button
                    className='btn btn-icon btn-success btn-sm me-1'
                    onClick={() => onOpenModal(TABLE_ACTION.VIEW, info.row.original)}
                  >
                    <i className='fs-6 bi bi-eye-fill'></i>
                  </Button>
                </>
                {!task?.approvable && (
                  <>
                    <Button
                      className='btn btn-icon btn-warning btn-sm me-1'
                      onClick={() => onOpenModal(TABLE_ACTION.EDIT, info.row.original)}
                    >
                      <i className='fs-6 bi bi-pencil-fill'></i>
                    </Button>
                    <Button
                      className='btn btn-icon btn-danger btn-sm me-1'
                      onClick={() => handleDelete(info.row.original)}
                    >
                      <i className='fs-6 bi bi-trash-fill'></i>
                    </Button>
                  </>
                )}
              </div>
            ) : (
              <div className='d-flex justify-content-center'>
                <>
                  <Button
                    className='btn btn-icon btn-success btn-sm me-1'
                    onClick={() => onOpenModal(TABLE_ACTION.VIEW, info.row.original)}
                  >
                    <i className='fs-6 bi bi-eye-fill'></i>
                  </Button>
                </>
              </div>
            )}
          </>
        ),
      },
      {
        header: 'Plant',
        accessorFn: (row) => row?.plant?.name || '',
        id: 'plant.name',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Discipline',
        accessorFn: (row) => row?.discipline?.name || '',
        id: 'discipline.name',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Tag Type',
        accessorFn: (row) => row?.tagType?.name || '',
        id: 'tagType.name',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Tag Number',
        accessorFn: (row) => row.code,
        id: 'code',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Tag Description',
        accessorFn: (row) => row.name,
        id: 'name',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Tag Status',
        accessorFn: (row) => row.status.name,
        id: 'status.name',
        cell: (info) => info.getValue(),
      },
    ]
    const columnsAdd: ColumnDef<any>[] = [
      {
        header: 'Tag Number',
        accessorFn: (row) => row.code,
        id: 'code',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Tag Description',
        accessorFn: (row) => row.name,
        id: 'name',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Status',
        accessorFn: (row) => row.status.name,
        id: 'status.name',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Task Number',
        accessorFn: (row) => row?.task?.darTaskCode,
        id: 'task.darTaskCode',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Action',
        id: 'action',
        cell: (info) => (
          <div className='d-flex justify-content-center'>
            {!info.row.original.task && (
              <>
                <Button
                  className='btn btn-icon btn-primary btn-sm me-1'
                  onClick={() => {
                    hanedleAddTag(info.row.original.id)
                  }}
                >
                  <i className='fs-6 bi bi-plus-lg'></i>
                </Button>
              </>
            )}
          </div>
        ),
      },
    ]

    setColumns(_columns)
    setColumnsAdd(columnsAdd)
  }, [task])

  useEffect(() => {
    setPlants([])
    setDisciplinesSearch([])
    setTagTypesList([])
    setAttributeTag([])
    formikFilterTag.setFieldValue('plantId', '')
    formikFilterTag.setFieldValue('disciplineId', '')
    formikFilterTag.setFieldValue('tagTypeId', '')
    formikFilterTag.setFieldValue('attributeGroupId', '')
    if (!formikFilterTag.values.companyId) return

    getPlants(formikFilterTag.values.companyId as string).then(async (res) => {
      await setPlants(res)
      await formikFilterTag.setFieldValue('plantId', formikFilter.values.plantId)
    })
  }, [formikFilterTag?.values?.companyId])

  useEffect(() => {
    formikFilterTag.setFieldValue('disciplineId', '')
    formikFilterTag.setFieldValue('tagTypeId', '')
    formikFilterTag.setFieldValue('attributeGroupId', '')
    setDisciplinesSearch([])
    setTagTypesList([])
    setAttributeTag([])
    if (!formikFilterTag.values.plantId) {
      setDisciplinesSearch([])
      return
    }
    getDisciplinesByPlantId(formikFilterTag.values.plantId, 'search')
  }, [formikFilterTag.values.plantId])

  useEffect(() => {
    formikFilterTag.setFieldValue('tagTypeId', '')
    formikFilterTag.setFieldValue('attributeGroupId', '')
    setTagTypesList([])
    setAttributeTag([])

    if (!formikFilterTag.values.disciplineId) {
      return
    }
    getTagTypeByDisciplineId(formikFilterTag.values.disciplineId)
  }, [formikFilterTag.values.disciplineId])
  useEffect(() => {
    formikFilterTag.setFieldValue('attributeGroupId', '')
    setAttributeTag([])

    if (!formikFilterTag.values.tagTypeId) {
      return
    }
    getAttributeByTagTypeId(formikFilterTag.values.tagTypeId)
  }, [formikFilterTag.values.tagTypeId])

  useEffect(() => {
    if (!isSuperAdmin && myCompany) {
      formikFilterTag.setFieldValue('companyId', myCompany.company.id)
    }
  }, [isSuperAdmin])

  useEffect(() => {
    handleGetTask(searchParams.get('id') as string)
  }, [pageOption.page, pageOption.sortBy, pageOption.order, pageOption.limit])

  useEffect(() => {
    if (!formikFilterTag.values.plantId) return
    getTagFilter()
  }, [
    pageOptionTag.page,
    pageOptionTag.sortBy,
    pageOptionTag.order,
    pageOptionTag.limit,
    formikFilterTag.values.plantId,
  ])

  const handleGetTask = async (id: string, tagNumber?: string, tagDescription?: string) => {
    formikFilter.setSubmitting(true)
    const getTaskById = new GetTaskByIdService()
    const _task = await getTaskById.request(
      id,
      pageOption,
      tagNumber || undefined,
      tagDescription || undefined
    )

    formikFilter.setValues({
      taskNumber: _task.data.taskNo,
      darNumber: _task.data.darTaskCode,
      darTaskId: _task.data.darTaskStudyCode,
      darTaskStudyCode: _task.data.darTaskStudyCode,
      companyGroup: '',
      remark: _task.data.remark || '-',
      company: _task.data.company.name,
      companyId: _task.data.company.id,
      plant: _task.data.plant.name,
      plantId: _task.data.plant.id,
      status: _task.data.status.name,
      rejectReason: _task.data.rejectReason,
    })
    setCompanyFilterTag(_task.data.company.id)
    setPlantFilterTag(_task.data.plant.id)
    formikFilterTag.setFieldValue('companyId', _task.data.company.id)

    setTags(_task.data.tags)
    setMeta(_task.meta)
    setTask(_task.data)
    formikFilter.setSubmitting(false)
  }

  const getTagFilter = async () => {
    const params = {
      plantId: plantFilterTag || undefined,
      disciplineId: formikFilterTag.values.disciplineId || undefined,
      tagTypeId: formikFilterTag.values.tagTypeId || undefined,
      attributeGroupId: formikFilterTag.values.attributeGroupId || undefined,
      tagCode: formikFilterTag.values.tagNumber || undefined,
      tagDescription: formikFilterTag.values.tagDescription || undefined,
      attributeValue: formikFilterTag.values.attributeValue || undefined,
    }
    const getTagFilter = new GetAvailableTagService()
    const _tag = await getTagFilter.request(pageOptionTag, params)
    // @ts-ignore
    setModalTags(_tag.data)
    // @ts-ignore
    setMetaTags(_tag.meta)
  }

  const onOpenModal = (type: TableAction, value?: any) => {
    if (type !== TABLE_ACTION.CREATE) {
      formik.setFieldValue('tagId', value.id)
      // const _res = JSON.parse(JSON.stringify(value.attributeGroups))
      for (let i in value.attributeGroups) {
        value.attributeGroups[i].isOpen = true
        // for (let j in _res[i].attributes) {
        //   // _res[i].attributes[j].value = ''
        // }
      }
      // formik.values.attributeGroups = JSON.parse(JSON.stringify(value.attributeGroups))
      formik.setFieldValue('attributeGroups', JSON.parse(JSON.stringify(value.attributeGroups)))
      setAttribute(JSON.parse(JSON.stringify(value.attributeGroups)))
      setTagSelected({
        code: value.code,
        name: value.name,
        isDemolished: value.isDemolished,
      })
    }
    setModalShow(true)
    setPageOptionTag(DEFAULT_PAGE_OPTION)
    setType(type)
  }
  const handleClose = () => {
    setModalShow(false)
    setModalAddTag(false)
  }
  const handleDelete = (value: any) => {
    Swal.fire(DEFAULT_CORMFIRM_MODAL(`Do you want to <br/>Delete Tag?`)).then(async (result) => {
      if (result.isConfirmed) {
        const params = {
          taskId: searchParams.get('id'),
          tagIds: [value.id],
        } as ITaskAddTag
        const deleteTag = new TaskDeleteTagService()
        deleteTag
          .request(params)
          .then((res) => {
            handleGetTask(searchParams.get('id') as string)
            getTagFilter()
          })
          .catch((err) => {
            Swal.fire(DEFAULT_ERROR_MODAL(err?.response?.data?.message || err.message))
          })
      }
    })
  }

  const hanedleAddTag = async (id: string) => {
    const params = {
      taskId: searchParams.get('id'),
      tagIds: [id],
    } as ITaskAddTag

    const addTag = new TaskAddTagService()
    addTag
      .request(params)
      .then((res) => {
        handleGetTask(searchParams.get('id') as string)
      })
      .catch((err) => {
        Swal.fire(DEFAULT_ERROR_MODAL(err?.response?.data?.message || err.message))
      })
      .finally(() => {
        getTagFilter()
        setModalAddTag(false)
      })
  }
  const hanedleEditTag = async () => {
    formik.setSubmitting(true)
    let attributes = [] as any
    for (let i in formik.values.attributeGroups) {
      const attr = formik.values.attributeGroups[i].attributes.map((el) => {
        return {
          id: el.attributeValueId,
          value: el.value,
        }
      })
      attributes.push(...attr)
    }
    let params = {
      taskId: searchParams.get('id'),
      tagId: formik.values.tagId,
      isDemolishTag: tagSelected.isDemolished,
      tagDescription: tagSelected.name,
      attributes: attributes,
    } as any

    const editTag = new TaskEditTagService()
    editTag
      .request(params)
      .then((res) => {
        handleGetTask(searchParams.get('id') as string)
        handleClose()
      })
      .catch((err) => {
        Swal.fire(DEFAULT_ERROR_MODAL(err?.response?.data?.message || err.message))
      })
      .finally(() => {
        formik.setSubmitting(false)
      })
  }

  const onReject = async (type: string) => {
    const {value: text} = await Swal.fire({
      input: 'textarea',
      title: 'Reject Reason',
      // inputLabel: 'Reject Reason',
      inputPlaceholder: 'Type your message here...',
      inputAttributes: {
        'aria-label': 'Type your message here',
      },
      showCancelButton: true,
    })
    if (text) {
      const sanitizedContent = DOMPurify.sanitize(text)

      Swal.fire(DEFAULT_CORMFIRM_MODAL(`Do you want to <br/>Reject Task?`)).then((result) => {
        if (result.isConfirmed) {
          onApproval('reject', sanitizedContent)
        }
      })
    }

    // Swal.fire({
    //   title: 'Reject Reason',
    //   input: 'text',
    //   inputAttributes: {
    //     autocapitalize: 'off',
    //   },
    //   showCancelButton: true,
    //   // confirmButtonText: 'Look up',
    //   showLoaderOnConfirm: true,
    //   preConfirm: async (rejectReason) => {
    //     onApproval('reject', rejectReason)
    //   },
    //   allowOutsideClick: () => !Swal.isLoading(),
    // })
  }
  const onApproval = (type: string, rejectReason?: string) => {
    const params = {
      taskId: searchParams.get('id'),
      tags: tags.map((el) => {
        return {
          id: el.id,
          isApproved: type === 'approve' ? true : false,
        }
      }),
      rejectReason: rejectReason,
    } as ITaskApproval

    const approval = new TaskApprovalService()
    approval
      .request(params)
      .then((res) => {
        Swal.fire(
          DEFAULT_SUCCESS_MODAL(`${type === 'reject' ? 'Reject' : 'Approve'} Successfully!`)
        )
        onBack()
      })
      .catch((err) => {
        Swal.fire(DEFAULT_ERROR_MODAL(err?.response?.data?.message || err.message))
      })
  }
  const onSubmitApproval = () => {
    Swal.fire(DEFAULT_CORMFIRM_MODAL(`Do you want to <br/>Submit Tag?`)).then((result) => {
      if (result.isConfirmed) {
        const submitApproval = new TaskSubmitApprovalService()
        submitApproval
          .request(searchParams.get('id') as string)
          .then(async (res) => {
            await Swal.fire(DEFAULT_SUCCESS_MODAL('Submit Successfully!'))
            onBack()
          })
          .catch((err) => {
            Swal.fire(DEFAULT_ERROR_MODAL(err?.response?.data?.message || err.message))
          })
      }
    })
  }

  const getPlants = async (id: string) => {
    const getPlantService = new GetPlantByCompanyService()
    const _plants = await getPlantService.request(id)
    return _plants
  }

  const getDisciplinesByPlantId = async (plantId: string, type?: string) => {
    const getDisciplineService = new GetDisciplineByPlantService()
    const _disciplines = await getDisciplineService.request(plantId)
    if (type === 'search') {
      setDisciplinesSearch(_disciplines.data)
    }
  }
  const getTagTypeByDisciplineId = async (disciplineId: string) => {
    const getDisciplineService = new GetTagTypeByDisciplineService()
    const _tagType = await getDisciplineService.request(disciplineId)
    setTagTypesList(_tagType.data)
  }
  const getAttributeByTagTypeId = async (tagTypeId: string) => {
    const getAttributeByTagTypeIdService = new GetAttributeByTagTypeIdService()
    const _res = await getAttributeByTagTypeIdService.request(tagTypeId)
    // formik.values.attributeGroups = [..._res]
    for (let i in _res) {
      _res[i].isOpen = false
      for (let j in _res[i].attributeTypes) {
        _res[i].attributeTypes[j].value = ''
      }
    }
    setAttributeTag(_res)
  }
  const onExport = async () => {
    const exportReportService = new ExportTagInTaskService()
    const _report = await exportReportService.request(searchParams.get('id') as string)
    const buffer = new Uint8Array(_report.data)
    exportFile(buffer, 'task.xlsx', 'buffer')
  }
  const onBack = () => {
    navigate('/tasks')
  }
  return (
    <>
      <Card>
        <Card.Body>
          <h1 className='mb-5'>
            {'AIMS-TAG > '}
            <Link to='/tasks'> Task Management </Link>
            {' > Assign Tag'}
          </h1>
          <Row>
            <Col xs={12} sm={6} md={4}>
              <TextField disabled formik={formikFilter} name={'company'} label='Company' />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <TextField disabled formik={formikFilter} name={'plant'} label='Plant' />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <TextField disabled formik={formikFilter} name={'status'} label='Status' />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <TextField disabled formik={formikFilter} name={'taskNumber'} label='Task Number' />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <TextField
                disabled
                formik={formikFilter}
                name={'darNumber'}
                label='DAR Task Number'
              />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <TextField
                disabled
                formik={formikFilter}
                name={'darTaskStudyCode'}
                label='DAR Task Study Number'
              />
            </Col>
            <Col xs={12} sm={6}>
              <TextField
                textarea
                disabled
                formik={formikFilter}
                name={'remark'}
                label='DAR Description'
              />
            </Col>
            <Col xs={12} sm={6}>
              <TextField
                textarea
                disabled
                formik={formikFilter}
                name={'rejectReason'}
                label='Reject Reason'
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6} md={4}>
              <TextField formik={formikFilter} name={'tagNumber'} label='Tag Number' />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <TextField formik={formikFilter} name={'tagDescription'} label='Tag Description' />
            </Col>
            <Col xs={12} sm={6} md={4} className='mt-7 justify-end'>
              <ButtonComp
                variant='primary'
                onClick={() => formikFilter.submitForm()}
                doing={formikFilter.isSubmitting}
                icon='bi bi-search'
              >
                Search
              </ButtonComp>
            </Col>
          </Row>
          <Row>
            <TableData
              data={tags || []}
              columns={columns}
              meta={meta}
              setMeta={setMeta}
              pageOption={pageOption}
              setPageOption={setPageOption}
              doing={formikFilter.isSubmitting}
            />
          </Row>
          <Row>
            <Col xs={12} className='mt-5' style={{justifyContent: 'flex-end', display: 'flex'}}>
              <ButtonComp
                variant='secondary'
                onClick={() => onBack()}
                doing={formik.isSubmitting || formikFilter.isSubmitting}
              >
                Back
              </ButtonComp>
              <ButtonComp
                variant='success'
                onClick={() => onExport()}
                doing={formik.isSubmitting || formikFilter.isSubmitting}
                disabled={!task?.exportable}
                icon='bi bi-file-earmark-arrow-up'
              >
                Export
              </ButtonComp>
              {task?.canAssignTag && (
                <ButtonComp
                  variant='success'
                  onClick={() => setModalAddTag(true)}
                  doing={formik.isSubmitting || formikFilter.isSubmitting}
                >
                  <i className='bi bi-plus-lg' />
                  Create tag
                </ButtonComp>
              )}
              {task?.canAssignTag && (
                <ButtonComp
                  variant='success'
                  onClick={() => onOpenModal(TABLE_ACTION.CREATE)}
                  doing={formik.isSubmitting || formikFilter.isSubmitting}
                >
                  <i className='bi bi-plus-lg' />
                  Add tag
                </ButtonComp>
              )}
              {!task?.updatable && !task?.approvable ? (
                <></>
              ) : task?.approvable ? (
                <>
                  <ButtonComp
                    variant='danger'
                    onClick={() => onReject('reject')}
                    doing={formik.isSubmitting || formikFilter.isSubmitting}
                  >
                    Reject
                  </ButtonComp>
                  <ButtonComp
                    variant='primary'
                    onClick={() => onApproval('approve')}
                    doing={formik.isSubmitting || formikFilter.isSubmitting}
                  >
                    Approve
                  </ButtonComp>
                </>
              ) : (
                <>
                  <ButtonComp
                    variant='primary'
                    onClick={() => onSubmitApproval()}
                    disabled={tags.length === 0}
                    doing={formik.isSubmitting || formikFilter.isSubmitting}
                  >
                    Submit
                  </ButtonComp>
                </>
              )}
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Modal show={modalShow} onHide={handleClose} centered size='lg' backdrop='static'>
        <form noValidate>
          <Modal.Header closeButton>
            <Modal.Title id='contained-modal-title-vcenter'>Assign Tag</Modal.Title>
          </Modal.Header>
          {type === TABLE_ACTION.CREATE && (
            <Modal.Body>
              <Row>
                <Col xs={12} sm={6} md={6}>
                  <Select
                    isCompany
                    formik={formikFilterTag}
                    name={'companyId'}
                    label='Company'
                    option={user?.companies || []}
                    keyLabel='name'
                    keyValue='id'
                    disabled
                  />
                </Col>
                <Col xs={12} sm={6} md={6}>
                  <Select
                    formik={formikFilterTag}
                    name={'plantId'}
                    label='Plant'
                    option={plants || []}
                    keyLabel='name'
                    keyValue='id'
                    disabled
                  />
                </Col>
                <Col xs={12} sm={6} md={6}>
                  <Select
                    formik={formikFilterTag}
                    name={'disciplineId'}
                    label='Discipline'
                    option={disciplinesSearch || []}
                    keyLabel='name'
                    keyValue='id'
                    isDefault
                  />
                </Col>
                <Col xs={12} sm={6} md={6}>
                  <Select
                    formik={formikFilterTag}
                    name={'tagTypeId'}
                    label='Tag Type'
                    option={tagTypesList || []}
                    keyLabel='name'
                    keyValue='id'
                    isDefault
                  />
                </Col>
                <Col xs={12} sm={6} md={6}>
                  <Select
                    formik={formikFilterTag}
                    name='attributeGroupId'
                    label='Attribute Group'
                    option={attributeTag || []}
                    keyLabel='name'
                    keyValue='id'
                    isDefault
                  />
                </Col>
                <Col xs={12} sm={6} md={6}>
                  <TextField formik={formikFilterTag} name={'tagNumber'} label='Tag Number' />
                </Col>
                <Col xs={12} sm={6} md={6}>
                  <TextField
                    formik={formikFilterTag}
                    name={'tagDescription'}
                    label='Tag Description'
                  />
                </Col>
                <Col xs={12} sm={6} md={6}>
                  <TextField
                    formik={formikFilterTag}
                    name={'attributeValue'}
                    label='Attribute Value'
                  />
                </Col>
                <Col xs={12} className='mt-5' style={{justifyContent: 'flex-end', display: 'flex'}}>
                  <ButtonComp variant='primary' onClick={() => getTagFilter()} icon='bi bi-search'>
                    Search
                  </ButtonComp>
                </Col>
              </Row>
              <Row>
                <TableData
                  data={modalTags || []}
                  columns={columnsAdd}
                  meta={metaTags}
                  setMeta={setMetaTags}
                  pageOption={pageOptionTag}
                  setPageOption={setPageOptionTag}
                  disabledLimit={true}
                />
              </Row>
            </Modal.Body>
          )}
          {type !== TABLE_ACTION.CREATE && (
            <>
              <Modal.Body>
                <Row>
                  <Col xs={12} sm={6} md={4}>
                    <Form.Group className='mb-3'>
                      <Form.Label>Tag Number</Form.Label>
                      <Form.Control type='text' disabled value={tagSelected.code} />
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={6} md={4}>
                    <Form.Group className='mb-3'>
                      <Form.Label>Tag Description</Form.Label>
                      <Form.Control
                        type='text'
                        disabled={type !== TABLE_ACTION.EDIT}
                        value={tagSelected.name}
                        onInput={(e: any) => setTagSelected({...tagSelected, name: e.target.value})}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={6} md={4}>
                    <Form.Group
                      className='mb-3'
                      style={{height: '100%', display: 'flex', alignItems: 'center', marginTop: 8}}
                    >
                      <input
                        id='isDemolished'
                        className='mx-2 checkbox-ad cursor-pointer'
                        type={'checkbox'}
                        checked={tagSelected.isDemolished}
                        onChange={() =>
                          setTagSelected({...tagSelected, isDemolished: !tagSelected.isDemolished})
                        }
                        disabled={type !== TABLE_ACTION.EDIT}
                      />
                      <Form.Label htmlFor='isDemolished' className='mt-1 cursor-pointer'>
                        Demolished
                      </Form.Label>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  {attribute.map((item, i) => {
                    return (
                      <div key={i}>
                        <Row>
                          <Col xs={12} className='mt-3'>
                            <div
                              onClick={() => {
                                attribute[i].isOpen = !attribute[i].isOpen
                                setAttribute([...attribute])
                              }}
                              aria-controls='example-collapse-text'
                              aria-expanded={item.isOpen}
                              style={{display: 'flex', justifyContent: 'space-between'}}
                            >
                              <h1>{item.name}</h1>
                              <i
                                className='bi bi-chevron-down'
                                style={{fontSize: 20, paddingRight: 40}}
                              ></i>
                            </div>
                          </Col>
                          <Col>
                            <Collapse in={item.isOpen}>
                              <Row>
                                {item.attributes.map((el, j) => {
                                  return (
                                    <Col xs={12} sm={6} md={{span: 4, offset: 1}} key={j}>
                                      <TextField
                                        required={el.isRequired}
                                        formik={formik}
                                        disabled={type === TABLE_ACTION.VIEW}
                                        name={`attributeGroups.${i}.attributes.${j}.value`}
                                        label={el.attributeTypeName}
                                        type={el.type}
                                        isInvalid={
                                          el.isRequired &&
                                          !formik.values.attributeGroups[i].attributes[j].value &&
                                          (el.isInvalid || formik.submitCount > 0)
                                        }
                                      />
                                    </Col>
                                  )
                                })}
                              </Row>
                            </Collapse>
                          </Col>
                        </Row>
                        <hr className='mt-3' />
                      </div>
                    )
                  })}
                </Row>
              </Modal.Body>
              {type === TABLE_ACTION.EDIT && (
                <Modal.Footer className='p-0 pb-2'>
                  <Row>
                    <Col
                      xs={12}
                      className='mt-5'
                      style={{justifyContent: 'flex-end', display: 'flex'}}
                      onClick={() => hanedleEditTag()}
                    >
                      <ButtonComp variant='primary' doing={formik.isSubmitting}>
                        Save
                      </ButtonComp>
                    </Col>
                  </Row>
                </Modal.Footer>
              )}
              {type === TABLE_ACTION.VIEW && (
                <Modal.Footer className='p-0 pb-2'>
                  <Row>
                    <Col
                      xs={12}
                      className='mt-5'
                      style={{justifyContent: 'flex-end', display: 'flex'}}
                      onClick={() => handleClose()}
                    >
                      <Button variant='primary' className='mx-1'>
                        Close
                      </Button>
                    </Col>
                  </Row>
                </Modal.Footer>
              )}
            </>
          )}
        </form>
      </Modal>
      <Modal show={modalAddTag} onHide={handleClose} centered size='xl' backdrop='static'>
        <Modal.Header closeButton>
          <Modal.Title id='contained-modal-title-vcenter'>Create Tag</Modal.Title>
        </Modal.Header>
        <RegisterTagDetail
          isAssignTag={true}
          hanedleAddTag={hanedleAddTag}
          taskDetail={formikFilter}
        />
      </Modal>
    </>
  )
}

export {AssignTaskPage}
